<template>
  <div>
    <Header title="隐私条款" />
    <div class="contianer">
      <div v-html="list" class="product_text"></div>
      <!-- <h4 class="size1">博世汽车技术服务（中国）有限公司个人信息保护政策</h4>
      <br />
      <h5>更新日期：【2023年8月21日】</h5>
      <br />

      <p>
        本《个人信息保护政策》（以下简称“<b>本政策</b>）阐述了【博世汽车技术服务（中国）有限公司
        】（以下统称为“<b>我们</b>”或“<b>公司</b>”）如何在您使用我们的【积分兑换服务】时处理来自您或者关于您的个人信息，【包括您使用或访问博世易加网微信端】；以及您接受适用本政策的我们的其他服务（上述统称为“<b>服务</b>”）。
      </p>
      <br />
      <p>
        在我们的业务和提供服务过程中，我们非常注重保护您的个人信息。我们将根据法律规定，收集、使用、存储、传输、共享和保护您的个人信息。个人信息指以电子或者其他方式记录的与已识别或者可识别的您个人有关的各类信息，不包括匿名化处理后的信息。我们的公司政策对数据保护和信息安全有着严格规定。：
      </p>
      <br />
      <p>
        <b>请您在使用我们的服务前，仔细阅读本政策，以便您更好地了解我们是如何处理您的个人信息的。</b>
      </p>
      <br />
      <p>本政策将帮助您了解以下内容：</p>
      <b>1、我们如何收集和使用您的个人信息</b><br />
      <b>2、我们如何保护您的个人信息</b><br />
      <b>3、我们如何存储、跨境传输您的个人信息</b><br />
      <b>4、我们如何共享、转让、公开披露您的个人信息</b><br />
      <b>5、您的权利</b><br />
      <b>6、Cookies和同类技术的使用</b><br />
      <b>7、APP的使用</b><br />
      <b>8、第三方在线服务</b><br />
      <b>9、未成年人保护</b><br />
      <b>10、本政策如何更新</b><br />
      <b>11、如何联系公司</b><br />
      <br />
      <h5 class="size2"><b>一、我们如何收集和使用您的个人信息</b></h5>
      <p>
        我们会根据合法、正当、必要、透明的原则，基于本政策所述的目的，收集您的个人信息。如果我们将您的个人信息用于本政策未载明的其他用途，或基于其他特定目的而收集您的个人信息，我们将以合理的方式告知您，并再次征得您的同意。
      </p>
      <b class="size3">1、我们将收集您的如下个人信息：</b><br />
      <b>(1)账户注册、登录和验证</b><br />
      <p>
        当您登录我们的产品时，您需要通过博世【身份认证服务（CIAM）】填写您的手机号（博世ID）用于登录验证。
      </p>
      <b>(2)交易信息</b><br />
      <p>
        当您在【博世易加网线上平台订购积分兑换服务时】，我们将会收集您的【收货人姓名、收货地址、收货联系人电话】，同时保存相关的服务信息 。
      </p>
      <b>(3)产品支持和售后服务</b><br />
      <p>
        【为了向您提供产品订单查询以及售后服务，保障您的交易安全】，我们将会获取您的【积分兑换订单信息】。当您与我们的客服人员联系要求我们【变更配送地址、联系人或联系电话】，我们可能需要您提供给出上述信息外的其他信息与您验核您的身份，包括您的【姓名、联系电话和地址】。
      </p>
      <b>(4)调研、问卷和订阅</b><br />
      <p>
        为了【分析用户数据和研究，升级我们的产品和服务并向您推送我们的产品宣传】，我们可能邀请您参与我们的【市场调研和线上活动】。您在参与活动时可能向我们提供您的【产品照片或视频】。
      </p>
      <b>(5)车主信息</b><br />
      <p>销售方提供的车主信息已经过车主确认并同意。</p>
      <b>(6)日志信息</b><br />
      为了更进一步优化我们的网站，并根据访问者的需求，更好地对网站进行更新。当您使用我们的服务时，包括浏览网站或者使用其他移动数据终端时，我们可能会自动收集相关信息，并储存在日志信息。<br />
      我们只会在达成本政策所述目的所需的期限内保留您的日志信息。为了预防事故和保障信息安全（例如为了调查网络攻击事件），日志信息需要作为证据继续保存的，在最终澄清相关事件之前，它们不会被删除，在个别情况下可能会被移交调查机构。<br />
      <p>
        日志信息包括：<br />

        •您访问在线服务的IP地址<br />
        •您通过哪个网站访问我们（Referrer URL）<br />
        •浏览的页面以及搜索信息<br />
        •下载的文件以及数量<br />
        •访问日期和时间（包括时长）<br />
        •传输的数据量<br />
        •操作系统和所使用的互联网浏览器的信息，包括所安装的附加组件（如Flash Player）<br />
        •http状态代码（如"重新请求成功 "或 "未找到请求的文件"）<br />
        【单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。】<br />
      </p>

      <b class="size3">2.您可选择提供给我们的您的个人信息的情形</b><br />
      <b>(1)地理位置信息</b><br />
      为了【提升您的用户体验和满足个性化需求】，实现【语言设定、位置设定】功能，我们可能会记录您设备所在的位置信息。当您使用服务时，我们可能会通过 IP地址、 GPS 、WLAN（如
      WiFi）或基站等途径获取您地理位置信息；您在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息。
      <br />
      您可以通过选择关闭您手机或浏览器设置中的定位服务拒绝我们访问您的位置数据。请注意，如果关闭了位置服务，移动应用程序的某些功能将无法按预期执行。<br />

      <b class="size3">3.我们从第三方获取的您的个人信息</b><br />
      您理解并知悉，在法律允许的情况下我们可能从第三方获取您的个人信息。<br />
      我们只会在确认第三方已经取得您的授权同意后再从该第三方收集您的个人信息。如果第三方的授权范围无法涵盖我们的处理和使用目的时，我们会自行或者要求该第三方征得您的同意后再行处理您的个人信息。<br />
      我们从第三方获取的您的个人信息的具体情形如下：<br />
      (1)出于安全和防欺诈的目的，针对特定账号、合同交易等服务，在您授权的前提下，通过合法来源核实您的个人信息（如电话号码）。<br />
      (2)我们可能从第三方获取您授权共享的账户信息（【授权页面提示的其他信息】），并在您同意本政策后将您的第三方账户与您的博世账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。<br />

      <b class="size3">4.基于合理和其他必要目的收集获取的您的个人信息</b><br />
      在以下情况下，我们可在不取得您同意的情况下收集您的个人信息：<br />
      (1)为了与您订立、履行合同所必需；<br />
      (2)履行法定职责或者法定义务所必需；<br />
      (3)应对突发公共卫生事件，或紧急情况下为保护您或他人的生命健康和财产安全所必需；<br />
      (4)为公共利益实施新闻报道，在合理的范围内处理个人信息；<br />
      (5)在合理的范围内处理您自行公开或者已经合法公开的个人信息；<br />
      (6)法律、行政法规规定的其他情形。<br />
      <br />

      <h5 class="size2"><b>二、我们如何保护您的个人信息</b></h5>
      <b class="size3">1.完善的信息安全管理系统</b><br />
      我们会采取一切合理可行的措施，保护收集的您的个人信息。公司内部已经实施了【信息安全管理系统（ISMS）,该系统是以ISO27001为标准而制定的】。<br />
      我们的信息安全管理系统定义了信息分类方法。根据分类，信息在存储和传输时需要加密，而且只允许使用先进的加密方法和去标识化等安全技术措施。同时我们实施了复杂的授权管理方法，其中权限的角色分为标准授权，关键授权或敏感授权。<br />
      我们将定期对于个人信息保护情况进行合规审计。<br />
      <b class="size3">2.进行安全评估、记录和保存</b> <br />
      在以下情形时，我们将事前进行个人信息保护影响评估，并对评估报告和处理情况依法进行记录和保存：<br />
      (1)处理您的敏感个人信息；<br />
      (2)利用个人信息进行自动化决策；<br />
      (3)委托处理个人信息，向第三方提供个人信息，公开个人信息；<br />
      (4)向境外提供个人信息；<br />
      (5)其他对个人权益有重大影响的个人信息处理活动。<br />

      <b class="size3">3.安全事件处置</b><br />
      我们将尽力确保您个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、泄露、篡改、或丢失，我们将立即采取补充措施，并按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。<br />
      我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们将会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<br />
      <br />

      <h5 class="size2"><b>三、我们如何存储、跨境传输您的个人信息</b></h5>
      <b class="size3">1.存储地点</b><br />
      原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。<br />
      <b class="size3">2.存储期限</b><br />
      我们将在您使用我们的服务期间及达成本政策所述目的所需的必要期限内为您保存您的个人信息，
      但法律要求或可更长保存期的除外。如果我们收到您申请注销您的注册账户或可验证的您删除个人信息的请求，我们将依据适用的法律法规规定停止使用，并删除您的个人信息或进行匿名化处理。<br />

      <h5 class="size2"><b>四、我们如何共享、转让、公开披露个人信息</b></h5>
      <b class="size3">1.与第三方共享或委托处理</b><br />
      原则上我们不会与任何公司、组织和个人分享您的个人信息，必要时我们可能与以下第三方共享并委托处理您的个人信息：<br />
      (1)执法部门、监管机构：依据法律法规的规定、诉讼、仲裁等争议解决需要，或按行政、司法机关依法提出的要求提供给相关机构或团体 ；<br />
      (2)关联公司：为了更好地向您提供我们的服务和产品以及出于业务运营需要，您的个人信息可能会与我们的关联公司共享。为了【向您提供更优质的产品和服务】，我们可能将您的【名字、手机号、微信OpenID，UnionID】分享给【附属公司或母公司】。<br />
      (3)第三方合作伙伴：我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的共享您的信息，第三方合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何目的。目前，我们的第三方合作伙伴，包括【物流供应商、数据中心、数据存储设施、客户服务供应商】，依据合作的业务内容不同，我们可能分享您的特定个人信息，包括【交易信息、日志信息、
      设备信息和标识符】。<br />
      (4)授权合作伙伴的SDK/API：为保障我们网页和移动客户端的稳定运行、功能实现，使您能够享受和使用更多的服务及功能，我们会嵌入授权合作伙伴的SDK或其他类似的工具。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。<br />
      <b class="size3">2.转让</b><br />
      我们不会将您的个人信息转让给任何公司、组织和个人，以下情况例外：<br />
      (1)在获取您的同意授权下，我们会向其他方转让您的个人信息。在此情况下，我们将取得您的单独同意，并告知您接收方的名称/姓名、联系方式、处理目的、处理方式和个人信息的种类。第三方变更对您个人信息的处理目的、处理方式的，将重新取得您的同意；<br />
      (2)当涉及合并、分立、解散或被宣告破产，公司需要将您的个人信息进行转让时，我们将告知您接收方的名称或者姓名和联系方式，并会要求接收方继续依法履行个人信息处理者的义务，保护您的个人信息安全。接收方变更原先的处理目的、处理方式的，应当依法重新取得您的同意。<br />
      <b class="size3">3.公开披露</b><br />
      我们仅会在以下情况下，公开披露您的个人信息：<br />
      (1)出于必要原因并事前获得您的单独同意；<br />
      (2)基于法律或合理依据的公开披露：包括法律法规规范、法律程序、诉讼或应政府主管部门要求。<br />
      <br />

      <h5 class="size2"><b>五、您的权利</b></h5>
      按照中国相关的法律法规，您对自己的个人信息可以行使以下权利：<br />
      <p><b class="size3">1. 查阅、复制、转移您的个人信息</b></p>
      您有权查阅、复制您的个人信息，法律法规规定的例外情况除外。如果您想行使您的个人信息查阅权，您可以依照指引，通过登录【我的→个人资料】获取对您个人信息的查阅，也可以联系我们查阅或复制您的个人信息。<br />
      如果您请求将您的个人信息转移至您指定的其他个人信息处理者，符合国家网信部门规定条件的，我们将相应提供转移的途径。<br />
      <b class="size3">2.更正和补充您的个人信息</b><br />
      当您发现我们处理的关于您的个人信息有错误或缺漏时，您有权要求我们做出更正和补充。<br />
      您可以通过本政策提供的联系方式与我们获得联系，以更正和补充您的个人信息。<br />
      <b class="size3">3.删除您的个人信息</b><br />
      在以下情形中，我们将主动删除您的个人信息；您也可以向我们提出删除个人信息的请求：<br />
      (1)如果我们处理您个人信息的目的已实现、无法实现或者实现处理目的不再必要；<br />
      (2)我们停止向您提供服务或者产品或者保存期限已届满；<br />
      (3)您个人撤回我们收集和处理您个人信息的同意的；<br />
      (4)我们违反法律、行政法规或者违反约定处理您的个人信息的；<br />
      (5)如果您注销了您的个人账户；<br />
      (6)法律、行政法规规定的其他情形。<br />
      在法律、行政法规规定的保存期限未届满，或者删除您的个人信息从技术上难以实现时，我们将停止除储存和采取必要的保护措施之外的处理。<br />
      <b class="size3">4.变更您授权同意的范围</b><br />
      您可以通过关闭相关功能、解除绑定账号、修改个人设置、删除相关信息等方式撤回部分授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。<br />
      请您理解，每个业务功能需要一些基本的个人信息才能得以实现，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。<br />
      <b class="size3">5.注销账户</b><br />
      您随时可注销已注册的账户，您可以联系我们来注销账户。<br />
      您注销账户后，我们将停止为您提供产品和/或服务，除法律法规另有规定外，我们将删除您的个人信息或对其进行匿名化处理。<br />
      <b class="size3">6.响应您的上述请求</b><br />
      为保障安全，我们可能会先要求您验证自己的身份（如要求您提供书面请求，或以其他方式证明您的身份），然后再处理您的请求。我们将在15个工作日内做出答复。<br />
      在以下情形中，我们将无法响应您的请求：<br />
      (1)与我们履行法律法规规定的义务相关的；<br />
      (2)与国家安全、国防安全直接相关的；<br />
      (3)与公共安全、公共卫生、重大公共利益直接相关的；<br />
      (4)与刑事犯罪侦查、起诉、审判和执行判决等直接相关的；<br />
      (5)有充分证据表明个人信息主体存在主观恶意或滥用权利的；<br />
      (6)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；<br />
      (7)响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br />
      (8)涉及商业秘密的。<br />
      <br />

      <h5 class="size2"><b>六、Cookies和同类技术的使用</b></h5>
      我们的微信端中没有Cookies和同类技术的使用。<br />
      <br />

      <h5 class="size2"><b>七、APP的使用</b></h5>
      我们暂不提供APP服务。<br />
      <br />

      <h5 class="size2"><b>八、第三方在线服务</b></h5>
      我们向您提供的服务可能会包含第三方在线服务的链接。这些其他链接可能在您访问他们时收集您的信息，并根据他们自己的个人信息保护政策处理这些信息。请您注意在访问时仔细阅读他们的个人信息保护政策。<br />
      <br />

      <h5 class="size2"><b>九、未成年人保护</b></h5>
      我们重视并依法保护未成年人个人信息的保护。没有父母或其他监护人的同意，未满18周岁的未成年人不得创建自己的主体账户。未满14周岁的儿童未经父母或其他监护人单独同意不得注册和使用我们的服务。<br />
      经父母或其他监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确单独同意或者保护未成年人所必要的情况下，收集和处理未成年人个人信息。<br />
      <br />

      <h5 class="size2"><b>十、本政策如何更新</b></h5>
      因公司业务和经营的变化或适用法律的变化，我们保留不时更新本政策的权利。我们将通过【登录弹窗及网站通知
      】方式提供经更新的本政策，请您及时查看以获得更新。对本政策的任何更新将在更新版的本政策发布后自更新之日起立即生效。在本政策更新后继续使用本政策项下服务，即表示您确认已阅读并理解更新后的政策。<br />
      本政策首页会显示最近一次更新的日期。对于重大变更，我们会向您就该重大变更提供适当通知。<br />
      本政策所指的重大变更包括但不限于：<br />
      1.处理个人信息的目的、处理的个人信息类型、个人信息的使用方式发生变化；<br />
      2.个人信息共享、转让或公开披露的主要对象发生变化；<br />
      3.您参与个人信息处理方面的权利及其行使方式发生重大变化；<br />
      4.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br />
      5.个人信息安全影响评估报告表明存在高风险时。<br />
      只有在获取您的同意后，我们才会按照更新后的本政策处理您的个人信息。<br />
      <br />

      <h5 class="size2"><b>十一、如何联系公司</b></h5>
      如果您对本政策有任何疑问、意见或建议，请通过以下方式与公司的信息收集方或数据安全管理部门联系，公司一般将在15个工作日内予以反馈。<br />
      联系方式如下：<br />
      信息收集及处理方联系方式：<br />
      电子邮件：bosch-extra@hcr.com.cn<br />
      电话：400-000-5109<br />
      数据安全部门联系方式：<br />
      电子邮件：China.DPO@cn.bosch.com<br /> -->

      <div class="uls_title2">历史版本</div>
      <div class="lis blue" @click="goMsg(index)" v-for="(item, index) in policyList" :index="index" :key="index">
        <p class="lis-L">
          <span class="lis-L-li">《<span class="updateMessage">{{ item.updateMessage }}</span>》</span>
        </p>
      </div>

    </div>

  </div>
</template>

<script>
import Header from '@/components/header'
import wxAppApi from '@/api/wx-app'
export default {
  components: {
    Header
  },
  data () {
    return {
      list: '',
      policyList: ''
    }
  },
  created () {
    this.getpolicyList()
  },
  methods: {
    getpolicyList () {
      var params = {}
      var that = this
      wxAppApi.policyList(params).then(res => {
        if (res.data.resultCode === '0') {
          console.log('res.data.===', res.data.resultData.privacyPolicyList)
          this.policyList = res.data.resultData.privacyPolicyList
          console.log('this.policyList===', this.policyList)
          that.policyInfo()
        }
      })
    },
    policyInfo () {
      var that = this
      var params = {
        id: this.policyList[0].id
      }
      wxAppApi.policyInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          var ruleMsg = res.data.resultData.privacyPolicyInfo.content
          that.list = ruleMsg
        }
      })
    },
    goMsg (index) {
      var id = this.policyList[index].id
      // wx.navigateTo({
      //   url: '/pages/login/ruleMsg/rule?id=' + id
      // })
      this.$router.push('/privacy')
      this.$router.push({
        name: 'privacy-msg',
        params: { id: id }
      })
    }

  }

}
</script>

<style scoped>
.updateMessage {
  text-decoration: underline;
}

.product_text {
  width: 100%;
}

.product_text>>>img,
.product_text>>>image {
  width: 100%;
  height: auto;
}

.product_text>>>p {
  width: 100%;
  height: auto;
}

.uls_title2 {
  font-size: 14px;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  color: #000;
  text-align: left;
  margin-bottom: 5px;
}

.lis {
  color: #007BC0;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 5px;
  font-size: 14px;
}

.lis-L {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  line-height: 20px;
}

.lis-L-li {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.contianer {
  width: calc(100vw - 16px);
  margin: 50px 8px 0 8px;
}

p,
li {
  font-size: 14px;
  line-height: 18px;
}

ul,
li,
dl,
dt,
dd,
ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.size1 {
  font-size: 25px;
  line-height: 30px;
}

.size2 {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
}

.size3 {
  font-size: 18px;
  line-height: 30px;
  font-weight: 600;
}
</style>
